import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { apis, hooks } from "@vote4dance/judging-sdk";
import { Loading } from './Loading';
var useSession = hooks.sessions.useSession;
var useConnectionState = apis.connections.useConnectionState;
export const PrivateOutlet = () => {
    const sessionState = useSession();
    const { isConnected } = useConnectionState();
    const hasSession = sessionState && sessionState.sessionInfo;
    const isAuthenticated = sessionState && sessionState.sessionInfo && sessionState.sessionInfo.user_id != "0";
    const showConnectionLoading = isAuthenticated && !isConnected;
    if (isAuthenticated) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Outlet, null),
            showConnectionLoading && React.createElement(Loading, null)));
    }
    if (!hasSession || !isConnected) {
        return React.createElement(Loading, null);
    }
    return React.createElement(Navigate, { to: "/login", replace: true, state: { from: window.location.href } });
};
